import { RANGE_OPTIONS, type RangeKey } from '../../lib/range';

export default function RangeTabs({
  value,
  onChange,
  customFrom,
  customTo,
  onCustomChange,
}: {
  value: RangeKey;
  onChange: (key: RangeKey) => void;
  customFrom?: string;
  customTo?: string;
  onCustomChange?: (from: string, to: string) => void;
}) {
  return (
    <div className="flex flex-col items-stretch sm:items-end gap-2">
      <div className="inline-flex rounded-md border border-background-200 bg-background-50 p-1">
        {RANGE_OPTIONS.map((opt) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChange(opt.key)}
            className={`px-3 py-1.5 text-xs font-semibold rounded-md whitespace-nowrap ${
              value === opt.key
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-600 hover:text-primary-600'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {value === 'custom' && customFrom && customTo && onCustomChange && (
        <div className="flex items-center gap-2">
          <input
            type="date"
            value={customFrom}
            max={customTo}
            onChange={(e) => onCustomChange(e.target.value, customTo)}
            className="px-2 py-1.5 text-xs rounded-md border border-background-200"
          />
          <span className="text-xs text-foreground-500">至</span>
          <input
            type="date"
            value={customTo}
            min={customFrom}
            onChange={(e) => onCustomChange(customFrom, e.target.value)}
            className="px-2 py-1.5 text-xs rounded-md border border-background-200"
          />
        </div>
      )}
    </div>
  );
}
